export default __webpack_public_path__ + "static/media/left-emergencia-mobile.e1ea9baf.png";